import { type ReactQuery } from 'cms-api'

export const parseStrapiErrorRequiredFields = (
  error: ReactQuery.ErrorError
): { path: string; name: string }[] => {
  const errors = error?.details?.errors as any[]
  return errors.map((err: any) => ({ path: err.path[0], name: err.name }))
}
